const docConversion = [
  {
    path: 'access-know',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: '接入须知', mdfilepath: '/ai/about.md' }
  },
  {
    path: 'api-auth',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: '接口鉴权', mdfilepath: '/ai/api-auth.md' }
  },
  {
    path: 'NLP',
    name: '',
    redirect: 'NLP/generic-word',
    component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
    meta: { title: '自然语言处理技术' },
    children: [
      {
        path: 'generic-word',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '上下位词', mdfilepath: '/ai/yuyan/api-ctx-words.md' }
      },
      {
        path: 'keyword-extraction',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '关键词提取', mdfilepath: '/ai/yuyan/api-key-words.md' }
      },
      {
        path: 'synonym',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '近义词发散', mdfilepath: '/ai/yuyan/api-similar-words.md' }
      },
      {
        path: 'topic-extraction',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '主题句提取', mdfilepath: '/ai/yuyan/api-key-sents.md' }
      },
      {
        path: 'text-summary',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '文本摘要', mdfilepath: '/ai/yuyan/api-text-summary.md' }
      },
      {
        path: 'new-word-descovery',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '新词发现', mdfilepath: '/ai/yuyan/api-new-words.md' }
      }
    ]
  },
  {
    path: 'intelligent-write',
    name: '',
    redirect: 'intelligent-write/material-recommand',
    component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
    meta: { title: '智能写作技术' },
    children: [
      {
        path: 'material-recommand',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '素材推荐', mdfilepath: '/ai/xiezuo/api-recommend.md' }
      },
      {
        path: 'text-generate',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '文本生成', mdfilepath: '/ai/xiezuo/api-autogen.md' }
      },
      {
        path: 'text-check',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '文本校对', mdfilepath: '/ai/xiezuo/api-corrector.md' }
      },
      {
        path: 'tang-poem-generate',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '唐诗自动生成', mdfilepath: '/ai/xiezuo/api-poem-tang.md' }
      },
      {
        path: 'song-poem-generate',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '宋词自动生成', mdfilepath: '/ai/xiezuo/api-poem-song.md' }
      }
    ]
  },
  {
    path: 'produce-exp',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: '产品体验', mdfilepath: '/ai/experience.md' }
  },
  {
    path: 'error-code',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: '常见错误码', mdfilepath: '/ai/error-code.md' }
  },
  {
    path: 'charge-standard',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: '计费方式', mdfilepath: '/ai/calculate-the-cost.md' }
  }
]

export default docConversion
